"use strict";
exports.__esModule = true;
exports.AvatarGroup = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@material-ui/core");
var lab_1 = require("@material-ui/lab");
var react_1 = tslib_1.__importDefault(require("react"));
var useStyles = core_1.makeStyles(function (theme) {
    return core_1.createStyles({
        bordercolor: {
            '& > div': {
                border: function () { return "1px solid " + theme.palette.action.disabled; }
            }
        }
    });
});
function AvatarGroup(props) {
    var classes = useStyles(props);
    return react_1["default"].createElement(lab_1.AvatarGroup, tslib_1.__assign({ className: classes.bordercolor }, props));
}
exports.AvatarGroup = AvatarGroup;
//# sourceMappingURL=AvatarGroup.js.map